module.exports = __webpack_public_path__ + "static/media/share_icon_weixin@2x.a7c89915.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/share/share_icon_weixin@2x.png
// module id = 64
// module chunks = 0